export default "__VITE_ASSET__CsxtJEqT__"